/**
 * @fileoverview คำนวณวันหมดประกัน (นับรวมวันเริ่มเป็นวันแรก) - สูตรเดียวกับ CMMS-Frontend utils/warranty.js
 * @module utils/warranty
 */
const parseYmd = (value) => {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value).trim());
  if (match) return { y: Number(match[1]), m: Number(match[2]) - 1, d: Number(match[3]) };
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return { y: date.getFullYear(), m: date.getMonth(), d: date.getDate() };
};

const formatYmd = (utcMs) => new Date(utcMs).toISOString().split("T")[0];

/** วันที่ + N วัน (N ติดลบได้) -> yyyy-mm-dd */
export const addDaysToDate = (dateString, days) => {
  const p = parseYmd(dateString);
  if (!p) return "";
  return formatYmd(Date.UTC(p.y, p.m, p.d + Number(days || 0)));
};

/**
 * วันหมดประกัน = วันเริ่ม + N เดือน - 1 วัน (วันเริ่มนับเป็นวันแรก)
 * ถ้าเดือนปลายทางไม่มีวันที่นั้น (ต้อง clamp เช่น 31 ม.ค. + 1 เดือน) = วันสุดท้ายของเดือนปลายทาง (ไม่ -1)
 * ตัวอย่าง: 2026-10-01 + 12 -> 2027-09-30 · 2027-01-31 + 1 -> 2027-02-28 · 2028-01-30 + 1 -> 2028-02-29 · 03-01 + 1 -> 03-31
 * N = 0 คืนวันเริ่มเอง (ไม่ถอยก่อนวันเริ่ม)
 */
export const calcWarrantyExpireDate = (startDateString, months) => {
  const p = parseYmd(startDateString);
  const n = parseInt(months, 10);
  if (!p || Number.isNaN(n)) return "";
  if (n === 0) return formatYmd(Date.UTC(p.y, p.m, p.d));
  const target = p.m + n;
  const lastDay = new Date(Date.UTC(p.y, target + 1, 0)).getUTCDate();
  if (p.d > lastDay) return formatYmd(Date.UTC(p.y, target, lastDay));
  return formatYmd(Date.UTC(p.y, target, p.d) - 24 * 60 * 60 * 1000);
};

/** จำนวนเดือนที่ย้อนกลับจาก calcWarrantyExpireDate ได้ = N มากสุดที่วันหมดของ N เดือน <= วันหมดที่ระบุ */
export const calcWarrantyMonthDiff = (startDateString, expireDateString) => {
  const s = parseYmd(startDateString);
  const e = parseYmd(expireDateString);
  if (!s || !e) return 0;
  const estimate = (e.y - s.y) * 12 + (e.m - s.m);
  const expireKey = formatYmd(Date.UTC(e.y, e.m, e.d));
  for (let n = estimate + 1; n > 0; n -= 1) {
    const candidate = calcWarrantyExpireDate(startDateString, n);
    if (candidate && candidate <= expireKey) return n;
  }
  return 0;
};
